import React from 'react'
import { Divider, Grid } from '@mui/material'
import Container from '../container'
import LinkPanel from './link-panel'
import Legal from './legal'
import makeStyles from '@mui/styles/makeStyles'
import ContentLinks from './content-links'
import { usePaidConsumer } from '../../hooks'

const useStyles = makeStyles(({ palette, spacing }) => ({
  paidConsumerfooterContainer: {
    marginTop: spacing(0)
  },
  content: {
    paddingBottom: spacing(7)
  },
  consumerContent: {
    paddingBottom: spacing(7),
    backgroundColor: palette.grey.shade[5]
  },
  divider: {
    backgroundColor: palette.grey.shade[20],
    marginBottom: spacing(7),
    width: '100%',
    maxWidth: 1440
  },
  dividerContainer: {
    display: 'flex',
    justifyContent: 'center',
    paddingLeft: spacing(5),
    paddingRight: spacing(5)
  }
}))

const PageFooterConsumer = () => {
  const { isPaidConsumer } = usePaidConsumer()
  const classes = useStyles()
  return (
    <Container className={isPaidConsumer && classes.paidConsumerfooterContainer}>
      <Grid
        container
        direction='column'
        alignItems='stretch'
        className={classes.consumerContent}
      >

        <Grid item>
          <ContentLinks />
        </Grid>

        <Grid item>
          <Container inset={2}>
            <div className={classes.dividerContainer}>
              <Divider className={classes.divider} />
            </div>
            <LinkPanel />
          </Container>
        </Grid>
      </Grid>
      <Grid item>
        <Legal />
      </Grid>
    </Container>
  )
}

export default PageFooterConsumer
